import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const sidebarSectionTitleDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),

    getText: () => base.text(),
  };
};
